import styled from "styled-components";
import themes from "@/styles/themes";
import {mdiAlertCircle, mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import {SET_MODAL} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Events from "@/utils/Events";
import { useEffect } from "react";
import { AnotherOfferButton } from "../impossibilidadeEntrega";

const Block = styled.div`
  background: white;
  padding: 34px 38px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  position: relative;
`
const ContentArea = styled.div`
  color: ${themes.greyNormal};
  position: relative;
  width: 258px;
`
const IconDiv = styled.div`
  background: ${themes.estadao};
  color: ${themes.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 6px 0;
`
const CallAction = styled.p`
  font-size: 20px;
  color: ${themes.estadao};
  font-weight: 700;
  line-height: 1.33;
  margin: 6px 0;
`
const Text = styled.p`
  font-size: 12px;
  margin: 6px 0;
  line-height: 14px;
`
const SubTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  margin: 6px 0;
  font-weight: bold;
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color:#1e1e21;
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;

  svg {
    width: 14px;
    height: 14px;
  }
`

interface IPrice {
  data: {
    oldPrice?: string;
    newPrice?: string;
  } 
}
export default function MudancaPreco(props:IPrice) {
  const offer_type = useSelector(GET_OFFER_TYPE)
  const events = new Events();
  useEffect(()=>{
    events.trigger("endereco_entrega_alteracao_preco", { offer_type })
  });
    const dispatch = useDispatch();
    const oldPrice = props.data.oldPrice
    const newPrice = props.data.newPrice
    console.log('props mP', props.data)
    const exitModal = () => {
      dispatch(SET_MODAL({type: null, show: false}))
      events.trigger("endereco_entrega_fechar_alteracao_preco", { offer_type })
    }

    return (
        <Block>
            <CloseButton onClick={exitModal}>
              <Icon path={mdiClose} size={1}></Icon>
            </CloseButton>

            <ContentArea>
                <IconDiv>
                    <Icon path={mdiAlertCircle} size={1} color={'#fff'}/>
                </IconDiv>
                <CallAction>
                Alteração de preço
                </CallAction>
                <Text>
                  O valor a ser pago foi de R$ {oldPrice} para R$ {newPrice}
                </Text>
                <SubTitle>
                  Por que isso aconteceu?
                </SubTitle>
          <Text>
            O valor da assinatura de S/A O Estado de S. Paulo pode sofrer alteração de acordo com o CEP informado para a entrega do jornal
          </Text>
          <AnotherOfferButton
            onClick={exitModal}>
            Continuar
          </AnotherOfferButton>
            </ContentArea>
        </Block>
    )
}